import { useSnackbar } from 'notistack';
import React, { useEffect } from 'react';
import { Trans } from 'react-i18next';

import {
  useErrorsDispatch,
  useErrorsState,
} from '../pages/FinancialData/shared/ErrorContext/ErrorContext';
import { ErrorContextActionTypes } from '../pages/FinancialData/shared/ErrorContext/ErrorContext.types';

export function useCommonErrorWatcher() {
  const errorsState = useErrorsState();
  const dispatchErrors = useErrorsDispatch();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (errorsState && errorsState.error) {
      const error = errorsState.error;
      const errorText = error.statusText !== '' ? error.statusText : error.data.error;
      enqueueSnackbar(
        <>
          <Trans
            i18nKey={errorText ? `error:${errorText}` : 'error:defaultError'}
            defaults={
              'Something went wrong. Feel free to notify us via Livechat if this error occurs again.'
            }
            count={errorsState.count}
          />
          {errorsState.includeDetails && error.data.detail && (
            <>
              <br />
              {error.data.detail}
            </>
          )}
        </>,
        {
          variant: 'error',
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
        },
      );
      dispatchErrors({
        type: ErrorContextActionTypes.ClearError,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorsState]);
}
